import React, { useContext, useMemo, useState } from 'react';

import ActionButtonIcon from '~/componentes/ActionButtonIcon';
import Pagination from '~/componentes/Pagination';
import InputSelect from '~/componentes/Inputs/InputSelect';
import InputText from '~/componentes/Inputs/InputText';
import ShowConfirmacao from '~/utils/ShowConfirmacao';
import setRegex from '~/utils/setRegex';
import sistemaListStore, {
  sistemaListShowModal,
} from '~/pages/Sistema/componentes/SistemaList/ThisMainComponent/thisStore';

import {
  ButtonContainer,
  Container,
  FiltersContainer,
  Table,
  TableBody,
  TableBodyNobody,
  TableHeader,
} from './styles';

function formatDate(dateString) {
  if (!dateString) return '';
  const date = new Date(dateString);
  if (isNaN(date)) return '';
  const day = String(date.getDate()).padStart(2, '0');
  const month = String(date.getMonth() + 1).padStart(2, '0');
  const year = date.getFullYear();
  return `${day}/${month}/${year}`;
}

function CustomBodyContent({ data = [] }) {
  const { state, dispatch } = useContext(sistemaListStore);

  const [pageData, setPageData] = useState([]);
  const [filters, setFilters] = useState({ search: '', departamento: '' });

  const updateFilter = (key, value) => {
    setFilters(prev => ({ ...prev, [key]: value }));
  };

  const departamentoOptions = useMemo(() => {
    const departamentos = [...new Set(data.map(item => item?.departamento).filter(Boolean))];
    return [
      { value: '', label: 'Todos os departamentos' },
      ...departamentos.map(departamento => ({ value: departamento, label: departamento })),
    ];
  }, [data]);

  const filteredData = useMemo(() => {
    return data.filter(item => {
      const nome = item?.perfil?.usuario?.nome || '';
      const cpf = item?.perfil?.usuario?.cpf || '';

      const searchMatch =
        !filters.search ||
        nome.toLowerCase().includes(filters.search.toLowerCase()) ||
        cpf.includes(filters.search.replace(/\D/g, ''));

      const departamentoMatch =
        !filters.departamento || item?.departamento === filters.departamento;

      return searchMatch && departamentoMatch;
    });
  }, [data, filters]);

  function handleEdit(item) {
    dispatch(sistemaListShowModal({ edit: true }, item));
  }

  function handleDelete(item) {
    ShowConfirmacao(
      async () => {
        return state.requests.deleteOne({ id: item.id });
      },
      {
        message: `Tem certeza que deseja excluir o funcionário "${item?.perfil?.usuario?.nome}"?`,
        successModal: 'Funcionário excluído com sucesso!',
        errorModal: {
          defaultMessage: 'Ocorreu um erro ao excluir o funcionário. Por favor, tente novamente.',
        },
      },
    );
  }

  return (
    <Container>
      <FiltersContainer>
        <InputText
          label="Buscar"
          placeholder="Buscar por nome ou CPF"
          value={filters.search}
          onChange={e => updateFilter('search', e.target.value)}
        />
        <InputSelect
          label="Departamento"
          options={departamentoOptions}
          value={filters.departamento}
          onChange={e => updateFilter('departamento', e.target.value)}
        />
      </FiltersContainer>

      <Table>
        <TableHeader>
          <span>Nome Completo</span>
          <span>CPF</span>
          <span>Cargo Atual</span>
          <span>Departamento</span>
          <span>Data de Admissão</span>
          <span>Ações</span>
        </TableHeader>

        {pageData.length === 0 && <TableBodyNobody>Nenhum funcionário encontrado.</TableBodyNobody>}

        {pageData.map((item, index) => (
          <TableBody key={item?.id} hasBorder={index < pageData.length - 1}>
            <span>{item?.perfil?.usuario?.nome}</span>
            <span>
              {item?.perfil?.usuario?.cpf ? setRegex.setCpf(item.perfil.usuario.cpf) : ''}
            </span>
            <span>{item?.cargoAtual}</span>
            <span>{item?.departamento}</span>
            <span>{formatDate(item?.dataAdmissao)}</span>
            <ButtonContainer>
              <ActionButtonIcon
                icon="edit"
                toltipText="Editar funcionário"
                onClick={() => handleEdit(item)}
              />
              <ActionButtonIcon
                icon="delete"
                toltipText="Excluir funcionário"
                onClick={() => handleDelete(item)}
              />
            </ButtonContainer>
          </TableBody>
        ))}
      </Table>

      <Pagination data={filteredData} size={15} getInfo={({ pageData }) => setPageData(pageData)} />
    </Container>
  );
}

export default CustomBodyContent;
